import { TextArea, VStack } from "native-base";
import React, { useState } from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";

type AddInstructionModalProps = {
  modalVisible: boolean;
  instruction?: string;
  onClose: () => void;
  onSubmit: (instruction: string) => void;
};

const AddInstructionModal = ({
  modalVisible,
  instruction,
  onClose,
  onSubmit,
}: AddInstructionModalProps) => {
  const [text, setText] = useState(instruction || "");

  const onPressClose = () => {
    setText("");
    onClose();
  };

  const onPressSubmit = () => {
    onSubmit(text);
    onClose();
  };

  return (
    <Modal
      isOpen={modalVisible}
      onClose={onPressClose}
      Header="Observação"
      Body={
        <VStack py="2">
          <TextArea
            value={text}
            maxLength={300}
            numberOfLines={4}
            onChangeText={(text) => setText(text)}
            placeholder="Escreva com detalhes sua observação"
            mb="5"
            fontSize="md"
            autoCompleteType
          />
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton w="full" mb={22} onPress={onPressSubmit}>
            {instruction ? "Alterar" : "Adicionar"}
          </FormButton>
          <FormButton
            w="full"
            mb={22}
            colorScheme="white"
            textColor="primary.700"
            onPress={onPressClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default AddInstructionModal;
